/* eslint-disable react-refresh/only-export-components */
import { useMemo, useLayoutEffect, type ReactNode } from 'react'
import { getStrings, uiLocaleFor } from '@shared/i18n'
import type { StringTable } from '@shared/i18n'
import { useProfile } from '@/hooks/useProfile'
import { APP_NAME } from '@shared/constants'
import { I18nContext, useT } from '@/lib/i18n-hooks'

export { I18nContext, useT }

export function I18nProvider({ children }: { children: ReactNode }) {
  const profile = useProfile()

  // nativeLang is a language id (e.g. 'zh-hant'), not always a locale table
  // key — map it (→ 'zh-TW') or the chrome silently degrades to English.
  // html lang uses the SAME mapped locale so downstream locale consumers
  // (ShareSheet poster copy/date, snapshot locale) hit their zh-TW branches.
  const uiLocale = uiLocaleFor(profile.nativeLang)

  const strings = useMemo<StringTable>(() => getStrings(uiLocale), [uiLocale])

  useLayoutEffect(() => {
    document.documentElement.lang = uiLocale
  }, [uiLocale])

  useLayoutEffect(() => {
    document.title = `${APP_NAME} — ${strings['nav.appTitleSuffix']}`
  }, [strings])

  return <I18nContext.Provider value={strings}>{children}</I18nContext.Provider>
}
